<script setup>
import { onMounted } from "vue";
import { useUserStore } from "@/stores/user";

   const userStore = useUserStore();
   onMounted(async ()=> {
      await userStore.fetchUser();
   })
</script>
<template>
  <router-view/>
</template>

<style>

@media screen and (max-width: 575px) {
    .p-dialog[pc17] {
        width: 100vw !important;
    }
}


@media(max-width: 575px) {
    .p-dialog {
      width: 100vw !important;
        border-radius: 0 !important;
        height: 100vh !important;
        min-height: 100vh !important;
    }
}

@media(max-width: 768px) {
    .p-dialog {
      width: 100vw !important;
        border-radius: 0 !important;
        height: 100vh !important;
        min-height: 100vh !important;
    }
}



@media (max-width: 768px) {
  .only-desktop {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .only-mobile {
    display: none !important;
  }
}


.p-skeleton {
      background: #eff0f2 !important;
  }

  body {
    font-family: "Quicksand", serif !important;
  }
#app {
  font-family: "Quicksand", serif !important;
  font-optical-sizing: auto;
  font-weight: 100;
  font-style: normal;
  font-variation-settings:"wdth" 100;
  text-align: center;
  color: #2c3e50;
}



nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
